function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  viewBox: "0 0 24 24",
  xmlns: "http://www.w3.org/2000/svg"
}, props), /*#__PURE__*/React.createElement("path", {
  opacity: ".4",
  d: "M19.08 15.72c-.59-3.53-3.98-6.4-7.56-6.4-3.89 0-7.31 3.15-7.64 7.03-.13 1.5.35 2.92 1.34 3.99C6.2 21.41 7.58 22 9.08 22h4.68c1.69 0 3.17-.66 4.18-1.85 1.01-1.19 1.41-2.77 1.14-4.43z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M10.28 7.86a2.93 2.93 0 100-5.86 2.93 2.93 0 000 5.86zm6.66 1.17a2.44 2.44 0 100-4.88 2.44 2.44 0 000 4.88zm3.61 3.9a1.95 1.95 0 100-3.9 1.95 1.95 0 000 3.9zM3.94 10.98a2.44 2.44 0 100-4.88 2.44 2.44 0 000 4.88z"
})));